import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const regenerateAllDisputeEvidence = unaryRpc({
  name: "regenerateAllDisputeEvidence" as const,
  input: z.object({}),
  output: z.object({
    accountCount: z.number().int(),
    failedCount: z.number().int(),
  }),
});
